



























import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("QuestionnaireAnswer", {
      report: "report"
    })
  }
})
export default class BookingReportMeta extends Vue {}
